import { defineMeta } from '@/registry/types';

export const formSectionMeta = defineMeta({
  name: 'FormSection',
  level: 'organism',
  category: 'input',
  classification: 'custom',
  description: 'Titled, described grouping of related form fields with consistent spacing.',
  baseLibrary: 'custom',
  muiEquivalent: 'Box + Typography (composed)',
  a2uiEquivalent: 'FormSection / Fieldset',
  importPath: '@/organisms/FormSection',
  requiredProps: ['title', 'children'],
  optionalProps: ['description', 'divider'],
  supportedStates: ['default', 'with-divider'],
  designTokens: ['typography', 'spacing'],
  accessibility: ['Renders a section element; title gives the group context.'],
  usageExamples: [
    '<FormSection title="Notifications" description="How we reach you."><FormField label="Email" htmlFor="email"><TextField id="email" /></FormField></FormSection>',
  ],
  rules: [
    'The section title is subtitle1 and the description is body1. Pass them as props — do not rebuild the heading from Typography.',
  ],
  antiPatterns: ['Do not nest FormSections more than one level.'],
  mountsSurface: 'inline',
  llmSafe: true,
  whenToUse: ['Composite forms (settings, create/edit flows)'],
  whenNotToUse: ['Single isolated field'],
});

export default formSectionMeta;
